// src/components/Loading.jsx
import React from 'react';

// Dans Loading.jsx
const Loading = ({ message = "Chargement...", size = "large", fullHeight = false, minimal = false }) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-10 h-10", 
    large: "w-16 h-16"
  };

  const heightClass = minimal ? "" : (fullHeight ? "min-h-screen" : "min-h-[200px]");

  return (
    <div className={`flex flex-col items-center justify-center ${heightClass} space-y-4`}>
      <div className={`${sizeClasses[size]} border-4 border-slate-200 border-t-indigo-500 rounded-full animate-spin`}></div>
      <p className="text-slate-600 text-lg">{message}</p>
    </div>
  );
};

export default Loading;